import { SchedulerResourceGroups } from './scheduling-assistant-types';

const resourcesOrdered = ['Patient', 'Places', 'Doctors', 'SpecialConditions'];
const resourcesOrderedObject = Object.fromEntries(
  resourcesOrdered.map((key) => [key, true]),
);

export function sortResourceKeys(resources: SchedulerResourceGroups) {
  const result: string[] = resourcesOrdered.filter((key) => resources[key]);
  Object.keys(resources).forEach((key) => {
    if (!resourcesOrderedObject[key]) result.push(key);
  });
  return result;
}
